var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scroll)?_c('div',{staticClass:"Scroll-to-top",on:{"click":_vm.toTop}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }